import { useLayoutEffect } from "react";
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import * as am5percent from "@amcharts/amcharts5/percent";

function PieChartConsent(props) {
  let myData = props?.data || [];


  useLayoutEffect(() => {
    if (!myData?.length) return;
    let root = am5.Root.new("pieChart");

    root.setThemes([am5themes_Animated.new(root)]);

    // Function to set chart layout based on window width
    const setChartLayout = () => {
      if (window.innerWidth < 768) {
        chart.set("layout", root.verticalLayout);
        legend.set("centerX", am5.percent(50));
        legend.set("x", am5.percent(50));
        legend.set("marginTop", 20);
        legend.set("marginLeft", 0);
        legend.set("width", am5.percent(30));
      } else {
        chart.set("layout", root.horizontalLayout);
        legend.set("centerX", am5.percent(100));
        legend.set("x", am5.percent(80));
        legend.set("marginTop", 0);
        legend.set("marginLeft", 20);
        legend.set("width", am5.percent(30));
      }
    };

    var chart = root.container.children.push(
      am5percent.PieChart.new(root, {
        layout: root.horizontalLayout,
        innerRadius: am5.percent(50),
      })
    );

    // Define data
    let data = myData || [];

    // Create series
    let series = chart.series.push(
      am5percent.PieSeries.new(root, {
        name: "Consent",
        valueField: "count",
        categoryField: "consent",
      })
    );

    series.data.setAll(data);

    // Disabling labels and ticks
    series.labels.template.set("visible", false);
    series.ticks.template.set("visible", false);

    series.slices.template.states.create("active", {
      shiftRadius: 0,
      stroke: am5.color(0x995522),
      strokeWidth: 5,
    });

    let legend = chart.children.push(
      am5.Legend.new(root, {
        layout: root.verticalLayout,
      })
    );

    legend.data.setAll(series.dataItems);

    // Set initial layout based on window width
    setChartLayout();

    // Add event listener to update layout on window resize
    window.addEventListener("resize", setChartLayout);

    return () => {
      root.dispose();
      window.removeEventListener("resize", setChartLayout);
    };
  }, [myData]);

  if (!myData?.length) {
    return <h5 className="text-center p-4">No Data Available.</h5>;
  }
  return (
    <div
      id="pieChart"
      className="pie-chart"
      style={{ width: "100%", height: "200px" }}
    ></div>
  );
}

export default PieChartConsent;
